import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { HistoryEntry, User } from '../../cereri.interface';
import { CereriService } from '../../cereri.service';
import { AppFilesService } from 'src/app/services/app-files.service';
import { helper } from 'src/environments/helper';
import { FormControl, FormGroup } from '@angular/forms';
import { finalize } from 'rxjs';

@Component({
    selector: 'app-cereri-istoric',
    templateUrl: './cereri-istoric.component.html',
    styleUrls: ['./cereri-istoric.component.scss'],
})
export class CereriIstoricComponent implements OnInit, OnChanges {
    @Output() requestInfoUpdated: EventEmitter<void> = new EventEmitter();
    @Input() istoric: HistoryEntry[] = [];
    @Input() id_cerere!: number;
    @Input() user!: User;
    @Input() notifyIds: any = [];
    @Output() isLoading = new EventEmitter<boolean>();

    helper = helper;
    showCard = false;
    isLoadingOperator = false;
    isLoadingCitizen = false;
    isLoadingAll = false;
    isReportMessageLoading: { [key: number]: boolean } = {};
    filteredHistory!: HistoryEntry[];

    searchParamsForm!: FormGroup;

    initialFormValue = {
        defaultValue: '-1',
    };
    messageTypes = [
        { key: '--Toate--', value: '-1' },
        { key: 'Către cetățean', value: ['0', '1'] },
        { key: 'Intern', value: ['2', '3'] },
    ];

    resetForm() {
        this.searchParamsForm.reset(this.initialFormValue);
        this.showCard = true;
    }

    initFilterForm() {
        this.searchParamsForm = new FormGroup({
            messageType: new FormControl(this.initialFormValue.defaultValue),
        });
    }

    constructor(
        private cereriService: CereriService,
        private appFileService: AppFilesService
    ) { }

    ngOnChanges(changes: SimpleChanges): void {
        this.filterHistoryByType();
    }

    ngOnInit(): void {
        this.initFilterForm();
    }

    filterHistoryByType() {
        const selectedType = this.searchParamsForm?.get('messageType')?.value || '-1';

        if (selectedType === '-1') {
            this.filteredHistory = [...(this.istoric || [])];
        } else {
            this.filteredHistory = (this.istoric || []).filter(entry => selectedType.includes(entry.type.toString()));
        }
    }


    downloadDocument(file: any) {
        let fullPath = this.cereriService.downloadDocumentUrl + file.id;
        this.isLoading.emit(true);
        this.appFileService.downloadFile(fullPath)
            .then(() => {
                this.isLoading.emit(false);
            })
            .catch(err => {
                console.error('File download error: ', err);
                this.isLoading.emit(false);
            })
    }

    /*
     Pentru type-uri:
     1: Conv de operator + nota interna
     2: Conv de la cetatean
     3: Conv all
    */

    exportConv(type: number) {
        // Set the appropriate loading flag to true based on the type
        if (type === 1) this.isLoadingOperator = true;
        if (type === 2) this.isLoadingCitizen = true;
        if (type === 3) this.isLoadingAll = true;

        this.cereriService.exportHistory(this.id_cerere, type).subscribe({
            next: (data: Blob) => {
                const blobUrl = URL.createObjectURL(data);
                window.open(blobUrl, '_blank');
                this.resetLoadingFlags();
            },
            error: (error) => {
                console.error('Error exporting PDF:', error);
                this.resetLoadingFlags();
            }
        });
    }

    resetLoadingFlags() {
        this.isLoadingOperator = false;
        this.isLoadingCitizen = false;
        this.isLoadingAll = false;
    }

    resendMessage(cerereHistoryId: number) {
        this.isReportMessageLoading[cerereHistoryId] = true;
        this.cereriService.rePostMessage(cerereHistoryId).pipe(finalize(() => {
            this.isReportMessageLoading[cerereHistoryId] = false;
            // Refresh the cereri-detalii component
            this.requestInfoUpdated.emit();
        })).subscribe();
    }

    isDateExpired(expirationDate: string): boolean {
        // 2025-07-28 23:59:59
        const timestampExp = Date.parse(expirationDate);
        const timestampNow = new Date().valueOf();

        // console.log('time', timestampNow, timestampExp)
        const isExpired = timestampNow > timestampExp
        return isExpired;
    }
}
